(() => {
  function getComparisonSliderMode(sectionRoot) {
    if (!sectionRoot || !sectionRoot.classList.contains('comparison-slider--pdp-new')) {
      return 'default';
    }

    if (window.matchMedia('(max-width: 749px)').matches) return 'mobile';
    if (window.matchMedia('(max-width: 989px)').matches) return 'tablet';

    return 'desktop';
  }

  function updateComparisonSlider(sliderEl) {
    const swiper = sliderEl && sliderEl.swiper;

    if (!swiper || swiper.destroyed) return;

    swiper.update();

    if (typeof swiper.updateAutoHeight === 'function') {
      swiper.updateAutoHeight(0);
    }
  }

  function updateComparisonSliders(scope) {
    const root = scope || document;
    const sliders = root.querySelectorAll('.comparison-slider--pdp-new .comparison-slider__swiper');

    sliders.forEach(updateComparisonSlider);
  }

  function queueComparisonSliderUpdate(sliderEl) {
    requestAnimationFrame(function () {
      updateComparisonSlider(sliderEl);

      requestAnimationFrame(function () {
        updateComparisonSlider(sliderEl);
      });
    });
  }

  function initComparisonSliders(scope) {
    const root = scope || document;
    const sliders = root.querySelectorAll('.comparison-slider__swiper');

    sliders.forEach((sliderEl) => {
      if (typeof Swiper === 'undefined') return;

      const sectionRoot = sliderEl.closest('.comparison-slider') || root;
      const paginationEl = sectionRoot.querySelector('.swiper-pagination');
      const prevEl = sectionRoot.querySelector('.comparison-slider__nav--prev');
      const nextEl = sectionRoot.querySelector('.comparison-slider__nav--next');
      const isNew = sectionRoot.classList.contains('comparison-slider--new');
      const isPdpNew = sectionRoot.classList.contains('comparison-slider--pdp-new');
      const hasEnhancedNav = isNew || isPdpNew;
      const mode = getComparisonSliderMode(sectionRoot);

      if (sliderEl.dataset.comparisonSliderInitialized === 'true') {
        if (!isPdpNew) return;

        if (sliderEl.dataset.comparisonSliderMode !== mode && sliderEl.swiper) {
          sliderEl.swiper.destroy(true, true);
          sliderEl.dataset.comparisonSliderInitialized = 'false';
        } else {
          updateComparisonSlider(sliderEl);
          return;
        }
      }

      if (paginationEl) {
        paginationEl.innerHTML = '';
      }

      const config = {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true
      };

      if (isNew || isPdpNew) {
        config.autoHeight = true;
      }

      if (isPdpNew) {
        config.resizeObserver = true;
        config.updateOnWindowResize = true;
        config.observer = true;
        config.observeParents = true;
      }

      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      if (hasEnhancedNav && prevEl && nextEl) {
        config.navigation = {
          prevEl,
          nextEl
        };
      }

      // Default mode needs pagination; enhanced modes need pagination and/or nav.
      if (!config.pagination && !config.navigation) return;

      new Swiper(sliderEl, config);

      if (isPdpNew) {
        queueComparisonSliderUpdate(sliderEl);
      }

      sliderEl.dataset.comparisonSliderInitialized = 'true';
      sliderEl.dataset.comparisonSliderMode = mode;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initComparisonSliders(document);
    });
  } else {
    initComparisonSliders(document);
  }

  window.addEventListener('load', function () {
    initComparisonSliders(document);

    window.setTimeout(function () {
      updateComparisonSliders(document);
    }, 100);
  });

  document.addEventListener('bundle:after-switch', function () {
    initComparisonSliders(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initComparisonSliders(event && event.target ? event.target : document);
  });

  let resizeTimer;

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initComparisonSliders(document);
    }, 150);
  });

  window.addEventListener('orientationchange', function () {
    window.clearTimeout(resizeTimer);

    resizeTimer = window.setTimeout(function () {
      initComparisonSliders(document);
    }, 250);
  });
})();
